import {
  FETCH_HOSPITAL_AFFILIATION_START,
  FETCH_HOSPITAL_AFFILIATION_SUCCESS,
  FETCH_HOSPITAL_AFFILIATION_FAILURE,
} from '../constants/hospitalAffiliationsActionsTypes';

const initialState = {
  instance: {},
  isStarted: false,
  isLoad: false,
  isError: false,
  msg: null,
};

function hospitalAffiliation(state = initialState, action) {
  switch (action.type) {
    case FETCH_HOSPITAL_AFFILIATION_START:
      return {
        ...state,
        isStarted: true,
        isLoad: false,
        isError: false,
        msg: null,
      };
    case FETCH_HOSPITAL_AFFILIATION_SUCCESS:
      return {
        ...state,
        instance: action.payload,
        isStarted: false,
        isLoad: true,
        isError: false,
      };
    case FETCH_HOSPITAL_AFFILIATION_FAILURE:
      return {
        ...state,
        instance: {},
        isStarted: false,
        isLoad: true,
        isError: true,
        msg: action.payload,
      };
    default:
      return state;
  }
}

export default hospitalAffiliation;
